/**
 * Author(s) : Guru Dharshan
 * Purpose : This is a Speaker detail model Component for showing speaker information.
 */

import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { ReactComponent as Memo } from './../../assets/icons/memo.svg';
import { ReactComponent as Xmark } from './../../assets/icons/x-mark.svg';
import styles from './SpeakerDetail.module.scss';
import $ from 'jquery';

const SpeakerDetail = (props) => {
  const speakerDetailValue = props.speakerDetail;
  const setSpeakerDetailClose = props.setSpeakerDetailClose;
  const isSpeakerDetailClose = props.isSpeakerDetailClose;
  const img = require(`../../assets/images/${speakerDetailValue.image}`);

  const close = () => {
    setSpeakerDetailClose(true);
  };

  const openMail = () => {
    window.location = 'mailto:' + speakerDetailValue.mail;
  };

  useEffect(() => {
    setTimeout(() => {
      $('#sId').focus();
    }, 1000);
  }, [isSpeakerDetailClose]);
  return (
    <div
      id="sId"
      className={
        isSpeakerDetailClose
          ? `${styles.speakerDetailWrapperClose}`
          : styles.speakerDetailWrapper
      }
      tabIndex={0}
      onBlur={close}>
      <div className={styles.speakerDetaileHeader}>
        <Xmark className={styles.eventIcon} onClick={close}></Xmark>
      </div>
      <div className={styles.speakerContent}>
        <img src={img} alt={speakerDetailValue.name} />
        <p className={styles.speakerName}>{speakerDetailValue.name}</p>
        <p className={styles.speakerDesc}>Watch me out on</p>
        {speakerDetailValue.session.map((sessionId, index) => (
          <div className={styles.eventWrapper} key={index}>
            <p className={styles.eventName}>
              {speakerDetailValue.sessionData[sessionId].category}
            </p>
            <div className={styles.eventDetailWrapper}>
              <div className={styles.eventIconWrapper}>
                <Memo className={styles.eventIcon}></Memo>
              </div>
              <div className={styles.eventDetailsWrapper}>
                {speakerDetailValue.url === '' ? (
                  <p>{speakerDetailValue.sessionData[sessionId].title}</p>
                ) : (
                  <a href={speakerDetailValue.sessionData[sessionId].url}>
                    <p>{speakerDetailValue.sessionData[sessionId].title}</p>
                  </a>
                )}
                <p>
                  <span>{speakerDetailValue.sessionData[sessionId].date}, {speakerDetailValue.sessionData[sessionId].startTime} - {speakerDetailValue.sessionData[sessionId].endTime}
                   
                  </span>
                </p>
                <p>{speakerDetailValue.sessionData[sessionId].screen}</p>
              </div>
            </div>
          </div>
        ))}
        <div className={styles.speakerDetailFooter}>
          <p>Reach out to me at</p>
          <p onClick={openMail}>{speakerDetailValue.mail}</p>
        </div>
      </div>
    </div>
  );
};

export default SpeakerDetail;

SpeakerDetail.propTypes = {
  speakerDetail: PropTypes.object,
  setSpeakerDetailClose: PropTypes.func,
  isSpeakerDetailClose: PropTypes.bool,
};
